import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home'
import Header from './views/layout/Header'
import Footer from './views/layout/Footer'
import Me from './views/me/Index'
import MeAbout from './views/me/About'
import MeContact from './views/me/Contact'
import LegalDec from './views/me/LegalDeclaration'
import register from "@/views/register/register";
import login from "@/views/login/login";
import ContractList from "@/views/contract/ContractList"
import ContractDetails from "@/views/contract/ContractDetails"
import LawsList from "@/views/laws/LawsList";
import Search from "@/views/search/Search"
import AnnounceList from "@/views/announce/AnnounceList"
import UploadInfo from "@/views/announce/UploadInfo";
import AnnounceDetails from "@/views/announce/AnnounceDetails";
import Api from "@/views/share/Api";
import Details from "@/views/search/Details";
import Pay from "@/views/pay/Pay";
import User from "@/views/user/User";
import Test from "@/views/test/Index"
import HomeHeader from "@/views/layout/HomeHeader";
import HomeFooter from "@/views/layout/HomeFooter";
import Report from "@/views/search/Report"
import ReportDetails from "@/views/search/ReportDetails"
import UserAgreement from "@/views/me/UserAgreement"
Vue.use(Router)

let baseHF = { header: Header, footer: Footer}
export default new Router({
    routes: [
        {
            path: '/',
            components: { default:Home},
            meta:{
                title:"首页"
            }
        },
        {
            path: '/about',
            components: {...baseHF, default:MeAbout},
            meta:{
                title:"关于我们"
            }
        },
        {
            path: '/register',
            components: {default:register},
            meta:{title:"用户注册"}
        },
        {
            path: '/login',
            components: {default:login},
            meta:{title:"用户登陆"}
        },
        {
            path: '/contractList',
            components: {...baseHF, default:ContractList},
            meta:{title:"合同范本"}
        },
        {
            name: 'contractDetails',
            path: '/contractDetails/:id',
            components: {...baseHF, default:ContractDetails},
            meta:{title:"合同详情"}
        },
        {
            path: '/lawsList',
            components: {...baseHF, default: LawsList},
            meta:{title:"政策法规"}
        },
        {
            name: 'search',
            path: '/search',
            components: {...baseHF, default: Search},
            meta:{title:"信用查询"}
        },
        {
            path: '/announceList',
            components: {...baseHF, default: AnnounceList},
            meta:{title:"违约披露"}
        },
        {
            path: '/uploadInfo',
            components: {...baseHF, default: UploadInfo},
            meta:{title:"信息上传"}
        },
        {
            path: '/announceDetails',
            components: {...baseHF, default: AnnounceDetails},
            meta:{title:"披露详情"}
        },
        {
            path: '/api',
            components: {...baseHF, default: Api},
            meta:{title:"接口共享"}
        },
        {
            path: '/details/:id',
            components: {...baseHF, default:Details},
            meta:{title:"处罚详情"}
        },
        {
            name: 'pay',
            path: '/pay',
            components: {...baseHF, default: Pay},
            meta:{title:"充值中心"}
        },
        {
            path: '/user',
            components: {...baseHF, default: User},
            meta:{title:"报告记录"}
        },
        {
            path: '/test',
            components: { default: Test},
            meta:{title:"test"}
        },
        {
            name:'report',
            path: '/report',
            components: { ...baseHF,default: Report},
            meta:{title:"信用数据报告"}
        },{
            name:'report-details',
            path: '/reportDetails',
            components: {default: ReportDetails},
            meta:{title:"信用数据报告详情"}
        },
        {
            name:'user-agreement',
            path: '/userAgreement',
            components: {...baseHF,default: UserAgreement},
            meta:{title:"服务协议"}
        }
    ]
})
